import React from 'react';
import { TabbedView, TabList, Tab } from 'components/shared/TabbedView';
import { BetaLabel } from 'components/BetaProgram';

const ContentToggle = ({ updateToggleIndex, toggleIndex }) => {
  const handleSelect = index => {
    updateToggleIndex(index);
  };

  return (
    <div className="JourneyContentToggle">
      <TabbedView onSelect={handleSelect} selectedIndex={toggleIndex}>
        <TabList>
          <Tab>{t('contents.index.toggle.training_content')}</Tab>
          <Tab>
            {t('contents.index.toggle.learning_journeys')}
            <BetaLabel className="ml-8" whiteOnBlack />
          </Tab>
        </TabList>
      </TabbedView>
    </div>
  );
};

export default ContentToggle;
